module.exports = __webpack_public_path__ + "img/preimushhestva.810aa6c5.png";